import { Component } from 'opus-angular-seed-core';

@Component({
    bindings: {
        uibModalInstance: '=',
        sites: '='
    },
    template: `
        <div class="modal-header">
            <button type="button" class="close" ng-click="vm.uibModalInstance.dismiss()"></button>
            <h2>{{ 'general.Add form' | translate }}</h2>
        </div>
        <form>
            <div class="modal-body">
                <forms-forms-actions-general
                    form="vm.form"
                    sites="vm.sites"
                    tags="vm.tags"
                    repeat-count="vm.repeatCount"
                    is-certification-form="vm.FormService.isCertificationForm(vm.form.model)"
                />
                <div class="well color02" ng-if="vm.FormService.isCertificationForm(vm.form.model)">
                    <h2>{{ 'forms.Display settings' | translate }}</h2>
                    <forms-forms-actions-settings-display form="vm.form" />
                </div>
            </div>
            <div class="modal-footer" >
                <ul class="actions01">
                    <li class="primary"><button ng-click="vm.save()" class="btn main" type="button">{{ 'general.Add' | translate }}</button></li>
                    <li><button class="btn discrete" type="button" ng-click="vm.uibModalInstance.dismiss()">{{ 'general.Cancel' | translate }}</button></li>
                </ul>
            </div>
        </form>
    `
})
export default class {
    constructor ($state, $rootScope, lodash, FormFactory, FormResource, FormService) {
        this.form = FormFactory.create(new FormResource, model => model.$save());
        this.FormService = FormService;
        this.$state = $state;
        this.$rootScope = $rootScope;
        this.lodash = lodash;
        this.repeatCount = null; // default value for new form
        this.tags = [];
    }

    save () {
        this.$rootScope.$broadcast('set.formSiteIds');
        this.form.model.repeatCount = this.FormService.getRepeatForModel(this.repeatCount);
        this.FormService.finalizeModelBeforeSave(this.form.model);
        this.form.save()
            .then((response) => this.uibModalInstance.close(response));
    }
}



// WEBPACK FOOTER //
// ./src/app/components/modals/forms/add/index.js